var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createMedia as createV2Media, deleteMedia as deleteV2Media, getMedia as getV2Media, getMediaCondition as getV2MediaCondition, listMedia as listV2Media, reuploadMedia as reuploadV2Media, updateMedia as updateV2Media, } from './media-v2/module';
/**
 * Retrieve a list of media that matches the specified query parameters.
 */
export function listMedia(params, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return listV2Media(params, requestOptions);
    });
}
/**
 * Retrieve media by ID
 */
export function getMedia(id, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return getV2Media(id, requestOptions);
    });
}
/**
 * Create new media depending on entitlement
 */
export function createMedia(data, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return createV2Media(data, requestOptions);
    });
}
/**
 * Update existing media depending on entitlement
 */
export function updateMedia(id, data, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return updateV2Media(id, data, requestOptions);
    });
}
/**
 * Delete media depending on entitlement
 */
export function deleteMedia(ids, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return deleteV2Media(ids, requestOptions);
    });
}
/**
 * Reupload media (for replacing original upload or trimming assets)
 * Appears in media module because it is nested in the /media endpoint
 */
export function reuploadMedia(id, data, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return reuploadV2Media(id, data, requestOptions);
    });
}
/**
 * Get the condition of a specific media, noting whether or not it is publishable in feeds
 */
export function getMediaCondition(id, requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return getV2MediaCondition(id, requestOptions);
    });
}
